<template>
  <div :class="classes">
    <pt-page-title title="全部兑换记录" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="keyword">
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="primary" @click="exportAllOrder" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportHistoryAllOrder">导出历史</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
    <p :class="$style['balance-text']">总消费积分：<span :class="$style['balance-color']">{{totalConsume}}</span></p>
    <pt-integral-exchange-table :tableLabels="integralExchangeTableLabels" :paramsData="paramsData" ref="table">
        <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
              <el-button type="text" v-if="needShiping(scope.row)" @click="toShowDialog(scope.row,'订单发货')">发货</el-button>
              <!-- <el-button type="text" @click="toShowDialog(scope.row,'修改收货信息')">修改收货地址</el-button> -->
              <el-button type="text" v-if="needRefund(scope.row)" @click="refund(scope.row)">返还积分</el-button>
            </template>
        </el-table-column>
    </pt-integral-exchange-table>
    <el-dialog :visible="showDialog" :title="dialogTitle" @close="closeDialog" :class="$style['sampling-message-dialog']">
        <sampling-message :isList="true" @getOrderList="getOrderList" :order-id="send_id" @close="closeDialog" :orderDetail="orderDetail" :isIntegral="true"></sampling-message>
      </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import samplingMessage from '../../goods-order/pt-order-detail/sampling-message'
// import integralDialog from './integral-dialog'
import ptIntegralExchangeTable from './pt-integral-exchange-table/withData'
import { integralExchangeTableLabels, filterLabels } from './integral-exchange'

import {
  emptyObject
} from '@/utils/lifebankUtils'
import formMixins from 'mixins/form'
const prefixCls = 'pt-integral-exchange'

export default {
  name: 'pt-integral-exchange',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    table () {
      return this.$refs.table
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    },
    totalConsume: {
      type: [Number, String]
    },
    balance: {
      type: [Number, String]
    },
    goodsTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    addressList: {
      type: Array,
      default: function () {
        return []
      }
    },
    allMembers: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    ptIntegralExchangeTable,
    // integralDialog
    samplingMessage
  },
  watch: {
    groupList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'goodsGroupName') {
            item.options = val
          }
        })
      },
      deep: true
    },
    addressList: {
      handler (val) {
        if (val) {
          this.filterLabels.forEach(item => {
            if (item.value === 'goodsAddresses') {
              item.options = val
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    goodsTypeList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'goodsType') {
            this.$set(item, 'options', val)
          }
        })
      },
      deep: true
    },
    allMembers: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'memberLevel') {
            item.options = val.map(e => {
              return {
                label: e.name,
                value: e.code.toString()
              }
            })
          }
        })
      },
      deep: true
    }
  },
  data () {
    return {
      filterLabels: filterLabels,
      integralExchangeTableLabels: integralExchangeTableLabels,
      keyword: '',
      params: {},
      paramsData: {},
      showDialog: false,
      editAmount: {},
      dialogTitle: '',
      orderDetail: {},
      send_id: ''
    }
  },
  methods: {
    getOrderList () {
      this.$refs.table.getIntegralExchangeList(0)
      this.showDialog = false
    },
    exportHistoryAllOrder () {
      this.$router.push('/export-history/integral-exchange?name=points_order_export')
    },
    exportAllOrder () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          for (var key in this.params) {
            if (!this.params[key]) {
              this.$delete(this.params, key)
            }
            if (key === 'orderTime') {
              this.$delete(this.params[key], 'index')
              this.params = { ...this.params, ...this.params[key] }
              this.$delete(this.params, key)
            }
          }
          this.paramsData = { ...this.params, searchKey: this.searchKey }
          this.paramsData.orderStatus = this.paramsData.orderStatus === 'WAITING_FOR_PAYMENT_BALANCE' ? 'WAITING_FOR_PAYMENT' : this.paramsData.orderStatus
          this.$emit('exportAllOrder', this.paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    // 是否需要退款按钮
    needRefund (row) {
      let isBalanceWaitingPayment = row.status === 'WAITING_FOR_PAYMENT' && row.isBalanceWaitingPayment
      return (row.status !== 'WAITING_FOR_PAYMENT' || isBalanceWaitingPayment) && row.status !== 'CLOSED' && !(row.refundmentDetails && row.refundmentDetails.apply) && row.type !== 'CONTRACT'
    },
    // 是否需要发货按钮
    needShiping (row) {
      return row.status === 'DELIVERY' && row.requirements && row.requirements.requireShipping && !(row.refundmentDetails && row.refundmentDetails.apply)
    },
    toEdit (val) {
      this.editAmount = val
      this.showDialog = true
    },
    closeDialog (val) {
      this.showDialog = false
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter(false)
    },
    Filter (isFromRouter) {
      // this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'orderTime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.paramsData.orderStatus = this.paramsData.orderStatus === 'WAITING_FOR_PAYMENT_BALANCE' ? 'WAITING_FOR_PAYMENT' : this.paramsData.orderStatus
      this.paramsData = this.params
      this.$emit('getIntegralTotalConsume', this.paramsData)
    },
    search (val) {
      this.isFromRouter = false
      this.keyword = val
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'keyword', val)
    },
    emptySearch (val) {
      this.$delete(this.paramsData, 'keyword')
    },
    toDetail (val) {
      this.$router.push('./integral-exchange-detail/' + val.id + '/detail')
    },
    refund (val) {
      this.$router.push('./integral-exchange-detail/' + val.id + '/refund')
    },
    toShowDialog (val, title) {
      this.send_id = val.id
      this.orderDetail = val
      this.dialogTitle = title
      this.showDialog = true
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .balance-color {
    color: #606266;
    font-size: 25px;
  }
    .balance-text {
    text-align: right;
    color: #edbe81;
    margin-top: .3rem;
    padding-bottom: .2rem;
  }
</style>
